import { ADD_PRODUCT, DELETE_CART, MANAGE_QUANTITY, } from "./actionTypes"


// Function to generate an ID
function generateId() {
    return Math.random().toString(36).substr(2, 9);
}
const initialState = {
    products: [],
    carts: []
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PRODUCT:
            const newData = {
                id: generateId(),
                ...action.payload,
            }
            return {
                ...state,
                products: [
                    ...state.products,
                    newData
                ]
            }
        case MANAGE_QUANTITY:
            const { type, id } = action.payload;

            // get quantity of product
            const leftQuantity = state.products.find(single => single.id === id).quantity

            // checking product id is this available on carts
            const indexInCarts = state.carts.findIndex(single => single.id === id)

            // update product card quantity
            const updatedProduct = state.products.map(single => {
                if (single.id !== id) {
                    return single;
                }
                if (type === "increase") {
                    if (single.quantity > 0) {
                        return {
                            ...single,
                            quantity: single.quantity - 1,
                        }
                    }
                    return single
                } else {
                    const leftCartsQuantity = state.carts.find(single => single.id === id).quantity
                    if (leftCartsQuantity > 1) {
                        return {
                            ...single,
                            quantity: single.quantity + 1,
                        }
                    }
                }
                return single
            })
            // change quantity on carts 
            // when first time adding to cart
            if (indexInCarts < 0) {
                const newUpdatedCarts = [...state.carts, { id, quantity: 1 }]
                // update the state
                return {
                    products: updatedProduct,
                    carts: newUpdatedCarts,
                }
            }
            // if product exits on carts
            const newCarts = state.carts.map(single => {
                if (single.id !== id) {

                    return single
                }
                if (type === 'increase') {

                    if (leftQuantity) {
                        return {
                            ...single,
                            quantity: single.quantity + 1,
                        }
                    }
                    return single

                } else {
                    if (single.quantity > 1) {
                        return {
                            ...single,
                            quantity: single.quantity - 1,
                        }
                    }
                }
                return single
            })
            return {
                products: updatedProduct,
                carts: newCarts,
            }
        case DELETE_CART:

            const newProducts = state.products.map(single => {
                if (single.id === action.payload) {
                    return {
                        ...single,
                        quantity: single.quantity + state.carts.find(single => single.id === action.payload).quantity
                    }
                }
                return single
            })
            // delete form cars
            const newFilterCarts = state.carts.filter(single => {
                if (single.id === action.payload) {

                    return false
                }
                return true
            })
            return {
                products: newProducts,
                carts: newFilterCarts
            };
        default:
            return state
    }
}

export default reducer